// 客户费率列表
import { HttpGetCusRateList } from '@/service/billing';
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_orderStatus: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            isSuper: this.$store.state.userinfo.isSuper
        };
    },
    methods: {
        ajaxRequest: HttpGetCusRateList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: 'customerRateBillupdate',
                        params: { type: "add" },
                    });
                    break;
                case 'query':
                    var url = this.$router.resolve({
                        name: "customerRateBillupdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'customerRateBillupdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/customerRate/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, type, } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: true,
                params: id,
                operate: 'edit'
            },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: 'EQ_customerOrgId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'EQ_warehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.accountmanage_cost_currency', { defaultValue: "计费币种" }),
                    key: 'EQ_currency',
                    show: true,
                    tag: 'vSelect',
                    options: [
                        { value: 'USD', label: 'USD' }
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.line', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: "客户" }),
                    key: 'customerOrgName',
                },
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                },
                {
                    title: this.$t('global.common.line', { defaultValue: "项目" }),
                    key: 'lineCode',
                },
                {
                    title: this.$t('fbb.accountmanage_cost_currency', { defaultValue: "计费币种" }),
                    key: 'currency',
                    sortable: true
                }, {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: 'remark',

                }, {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',

                }];
        },
    },
};




